import { useSelector } from 'react-redux';

import { getLocaleDetails } from 'constants/LanguageConstants';
import { getLocale } from 'modules/i18n/selectors/data';
import { createDictionary } from 'utils/ObjectUtils';

const computeDisplayName = (args) => args.reduce((acc, value) => {
  if (value?.trim()) {
    return [...acc, value?.trim()];
  }
  return acc;
}, []).join(' ');

export const defaultDisplayNameFormatter = (user) => (
  user?.displayName || computeDisplayName([user?.firstName, user?.lastName])
);

export const formatDisplayLastNameFirst = (user) => computeDisplayName([user?.lastName, user?.firstName]) || (user?.displayName ?? '');

export const DISPLAY_NAME_FORMATTERS = createDictionary({
  ja: formatDisplayLastNameFirst,
  zh: formatDisplayLastNameFirst,
  ko: formatDisplayLastNameFirst,
}, defaultDisplayNameFormatter);

/**
 * @returns {(user?: { lastName?: string, firstName?: string, displayName?: string }) => string}
 */
export const useDisplayNameFormatter = () => {
  const locale = useSelector(getLocale);
  const { country } = getLocaleDetails(locale);

  return DISPLAY_NAME_FORMATTERS[country];
};
